import React from 'react';

import type { SnackMessageCreateFn } from 'src/types/snackbar';

import { SnackMessage } from './SnackMessage';

export const createSnackMessage: SnackMessageCreateFn = (variant, title) => (key, message) =>
  React.createElement(SnackMessage, { id: key, variant, message, title });
